// extracted by mini-css-extract-plugin
module.exports = {"switchAccount":"styles_switchAccount__3-N5v","browser-ie":"styles_browser-ie__Ivv6x","closed":"styles_closed___liHc","animating":"styles_animating__GK5ZL"};